"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageSummaryDate = void 0;
/**
 * Response with hourly report of all data billed by Datadog all organizations.
 */
class UsageSummaryDate {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return UsageSummaryDate.attributeTypeMap;
    }
}
exports.UsageSummaryDate = UsageSummaryDate;
/**
 * @ignore
 */
UsageSummaryDate.attributeTypeMap = {
    agentHostTop99p: {
        baseName: "agent_host_top99p",
        type: "number",
        format: "int64",
    },
    apmAzureAppServiceHostTop99p: {
        baseName: "apm_azure_app_service_host_top99p",
        type: "number",
        format: "int64",
    },
    apmDevsecopsHostTop99p: {
        baseName: "apm_devsecops_host_top99p",
        type: "number",
        format: "int64",
    },
    apmFargateCountAvg: {
        baseName: "apm_fargate_count_avg",
        type: "number",
        format: "int64",
    },
    apmHostTop99p: {
        baseName: "apm_host_top99p",
        type: "number",
        format: "int64",
    },
    appsecFargateCountAvg: {
        baseName: "appsec_fargate_count_avg",
        type: "number",
        format: "int64",
    },
    asmServerlessSum: {
        baseName: "asm_serverless_sum",
        type: "number",
        format: "int64",
    },
    auditLogsLinesIndexedSum: {
        baseName: "audit_logs_lines_indexed_sum",
        type: "number",
        format: "int64",
    },
    auditTrailEnabledHwm: {
        baseName: "audit_trail_enabled_hwm",
        type: "number",
        format: "int64",
    },
    avgProfiledFargateTasks: {
        baseName: "avg_profiled_fargate_tasks",
        type: "number",
        format: "int64",
    },
    awsHostTop99p: {
        baseName: "aws_host_top99p",
        type: "number",
        format: "int64",
    },
    awsLambdaFuncCount: {
        baseName: "aws_lambda_func_count",
        type: "number",
        format: "int64",
    },
    awsLambdaInvocationsSum: {
        baseName: "aws_lambda_invocations_sum",
        type: "number",
        format: "int64",
    },
    azureAppServiceTop99p: {
        baseName: "azure_app_service_top99p",
        type: "number",
        format: "int64",
    },
    billableIngestedBytesSum: {
        baseName: "billable_ingested_bytes_sum",
        type: "number",
        format: "int64",
    },
    browserRumLiteSessionCountSum: {
        baseName: "browser_rum_lite_session_count_sum",
        type: "number",
        format: "int64",
    },
    browserRumReplaySessionCountSum: {
        baseName: "browser_rum_replay_session_count_sum",
        type: "number",
        format: "int64",
    },
    browserRumUnitsSum: {
        baseName: "browser_rum_units_sum",
        type: "number",
        format: "int64",
    },
    ciPipelineIndexedSpansSum: {
        baseName: "ci_pipeline_indexed_spans_sum",
        type: "number",
        format: "int64",
    },
    ciTestIndexedSpansSum: {
        baseName: "ci_test_indexed_spans_sum",
        type: "number",
        format: "int64",
    },
    ciVisibilityItrCommittersHwm: {
        baseName: "ci_visibility_itr_committers_hwm",
        type: "number",
        format: "int64",
    },
    ciVisibilityPipelineCommittersHwm: {
        baseName: "ci_visibility_pipeline_committers_hwm",
        type: "number",
        format: "int64",
    },
    ciVisibilityTestCommittersHwm: {
        baseName: "ci_visibility_test_committers_hwm",
        type: "number",
        format: "int64",
    },
    cloudCostManagementAwsHostCountAvg: {
        baseName: "cloud_cost_management_aws_host_count_avg",
        type: "number",
        format: "int64",
    },
    cloudCostManagementAzureHostCountAvg: {
        baseName: "cloud_cost_management_azure_host_count_avg",
        type: "number",
        format: "int64",
    },
    cloudCostManagementGcpHostCountAvg: {
        baseName: "cloud_cost_management_gcp_host_count_avg",
        type: "number",
        format: "int64",
    },
    cloudCostManagementHostCountAvg: {
        baseName: "cloud_cost_management_host_count_avg",
        type: "number",
        format: "int64",
    },
    cloudSiemEventsSum: {
        baseName: "cloud_siem_events_sum",
        type: "number",
        format: "int64",
    },
    containerAvg: {
        baseName: "container_avg",
        type: "number",
        format: "int64",
    },
    containerExclAgentAvg: {
        baseName: "container_excl_agent_avg",
        type: "number",
        format: "int64",
    },
    containerHwm: {
        baseName: "container_hwm",
        type: "number",
        format: "int64",
    },
    csmContainerEnterpriseComplianceCountSum: {
        baseName: "csm_container_enterprise_compliance_count_sum",
        type: "number",
        format: "int64",
    },
    csmContainerEnterpriseCwsCountSum: {
        baseName: "csm_container_enterprise_cws_count_sum",
        type: "number",
        format: "int64",
    },
    csmContainerEnterpriseTotalCountSum: {
        baseName: "csm_container_enterprise_total_count_sum",
        type: "number",
        format: "int64",
    },
    csmHostEnterpriseAasHostCountTop99p: {
        baseName: "csm_host_enterprise_aas_host_count_top99p",
        type: "number",
        format: "int64",
    },
    csmHostEnterpriseAwsHostCountTop99p: {
        baseName: "csm_host_enterprise_aws_host_count_top99p",
        type: "number",
        format: "int64",
    },
    csmHostEnterpriseAzureHostCountTop99p: {
        baseName: "csm_host_enterprise_azure_host_count_top99p",
        type: "number",
        format: "int64",
    },
    csmHostEnterpriseComplianceHostCountTop99p: {
        baseName: "csm_host_enterprise_compliance_host_count_top99p",
        type: "number",
        format: "int64",
    },
    csmHostEnterpriseCwsHostCountTop99p: {
        baseName: "csm_host_enterprise_cws_host_count_top99p",
        type: "number",
        format: "int64",
    },
    csmHostEnterpriseGcpHostCountTop99p: {
        baseName: "csm_host_enterprise_gcp_host_count_top99p",
        type: "number",
        format: "int64",
    },
    csmHostEnterpriseTotalHostCountTop99p: {
        baseName: "csm_host_enterprise_total_host_count_top99p",
        type: "number",
        format: "int64",
    },
    cspmAasHostTop99p: {
        baseName: "cspm_aas_host_top99p",
        type: "number",
        format: "int64",
    },
    cspmAwsHostTop99p: {
        baseName: "cspm_aws_host_top99p",
        type: "number",
        format: "int64",
    },
    cspmAzureHostTop99p: {
        baseName: "cspm_azure_host_top99p",
        type: "number",
        format: "int64",
    },
    cspmContainerAvg: {
        baseName: "cspm_container_avg",
        type: "number",
        format: "int64",
    },
    cspmContainerHwm: {
        baseName: "cspm_container_hwm",
        type: "number",
        format: "int64",
    },
    cspmGcpHostTop99p: {
        baseName: "cspm_gcp_host_top99p",
        type: "number",
        format: "int64",
    },
    cspmHostTop99p: {
        baseName: "cspm_host_top99p",
        type: "number",
        format: "int64",
    },
    customTsAvg: {
        baseName: "custom_ts_avg",
        type: "number",
        format: "int64",
    },
    cwsContainerCountAvg: {
        baseName: "cws_container_count_avg",
        type: "number",
        format: "int64",
    },
    cwsHostTop99p: {
        baseName: "cws_host_top99p",
        type: "number",
        format: "int64",
    },
    date: {
        baseName: "date",
        type: "Date",
        format: "date-time",
    },
    dbmHostTop99p: {
        baseName: "dbm_host_top99p",
        type: "number",
        format: "int64",
    },
    dbmQueriesCountAvg: {
        baseName: "dbm_queries_count_avg",
        type: "number",
        format: "int64",
    },
    errorTrackingEventsSum: {
        baseName: "error_tracking_events_sum",
        type: "number",
        format: "int64",
    },
    fargateTasksCountAvg: {
        baseName: "fargate_tasks_count_avg",
        type: "number",
        format: "int64",
    },
    fargateTasksCountHwm: {
        baseName: "fargate_tasks_count_hwm",
        type: "number",
        format: "int64",
    },
    flexLogsComputeLargeAvg: {
        baseName: "flex_logs_compute_large_avg",
        type: "number",
        format: "int64",
    },
    flexLogsComputeMediumAvg: {
        baseName: "flex_logs_compute_medium_avg",
        type: "number",
        format: "int64",
    },
    flexLogsComputeSmallAvg: {
        baseName: "flex_logs_compute_small_avg",
        type: "number",
        format: "int64",
    },
    flexLogsComputeXsmallAvg: {
        baseName: "flex_logs_compute_xsmall_avg",
        type: "number",
        format: "int64",
    },
    flexStoredLogsAvg: {
        baseName: "flex_stored_logs_avg",
        type: "number",
        format: "int64",
    },
    forwardingEventsBytesSum: {
        baseName: "forwarding_events_bytes_sum",
        type: "number",
        format: "int64",
    },
    gcpHostTop99p: {
        baseName: "gcp_host_top99p",
        type: "number",
        format: "int64",
    },
    herokuHostTop99p: {
        baseName: "heroku_host_top99p",
        type: "number",
        format: "int64",
    },
    incidentManagementMonthlyActiveUsersHwm: {
        baseName: "incident_management_monthly_active_users_hwm",
        type: "number",
        format: "int64",
    },
    indexedEventsCountSum: {
        baseName: "indexed_events_count_sum",
        type: "number",
        format: "int64",
    },
    infraHostTop99p: {
        baseName: "infra_host_top99p",
        type: "number",
        format: "int64",
    },
    ingestedEventsBytesSum: {
        baseName: "ingested_events_bytes_sum",
        type: "number",
        format: "int64",
    },
    iotDeviceSum: {
        baseName: "iot_device_sum",
        type: "number",
        format: "int64",
    },
    iotDeviceTop99p: {
        baseName: "iot_device_top99p",
        type: "number",
        format: "int64",
    },
    mobileRumLiteSessionCountSum: {
        baseName: "mobile_rum_lite_session_count_sum",
        type: "number",
        format: "int64",
    },
    mobileRumSessionCountAndroidSum: {
        baseName: "mobile_rum_session_count_android_sum",
        type: "number",
        format: "int64",
    },
    mobileRumSessionCountFlutterSum: {
        baseName: "mobile_rum_session_count_flutter_sum",
        type: "number",
        format: "int64",
    },
    mobileRumSessionCountIosSum: {
        baseName: "mobile_rum_session_count_ios_sum",
        type: "number",
        format: "int64",
    },
    mobileRumSessionCountReactnativeSum: {
        baseName: "mobile_rum_session_count_reactnative_sum",
        type: "number",
        format: "int64",
    },
    mobileRumSessionCountRokuSum: {
        baseName: "mobile_rum_session_count_roku_sum",
        type: "number",
        format: "int64",
    },
    mobileRumSessionCountSum: {
        baseName: "mobile_rum_session_count_sum",
        type: "number",
        format: "int64",
    },
    mobileRumUnitsSum: {
        baseName: "mobile_rum_units_sum",
        type: "number",
        format: "int64",
    },
    ndmNetflowEventsSum: {
        baseName: "ndm_netflow_events_sum",
        type: "number",
        format: "int64",
    },
    netflowIndexedEventsCountSum: {
        baseName: "netflow_indexed_events_count_sum",
        type: "number",
        format: "int64",
    },
    npmHostTop99p: {
        baseName: "npm_host_top99p",
        type: "number",
        format: "int64",
    },
    observabilityPipelinesBytesProcessedSum: {
        baseName: "observability_pipelines_bytes_processed_sum",
        type: "number",
        format: "int64",
    },
    onlineArchiveEventsCountSum: {
        baseName: "online_archive_events_count_sum",
        type: "number",
        format: "int64",
    },
    opentelemetryApmHostTop99p: {
        baseName: "opentelemetry_apm_host_top99p",
        type: "number",
        format: "int64",
    },
    opentelemetryHostTop99p: {
        baseName: "opentelemetry_host_top99p",
        type: "number",
        format: "int64",
    },
    orgs: {
        baseName: "orgs",
        type: "Array<UsageSummaryDateOrg>",
    },
    profilingAasCountTop99p: {
        baseName: "profiling_aas_count_top99p",
        type: "number",
        format: "int64",
    },
    profilingHostTop99p: {
        baseName: "profiling_host_top99p",
        type: "number",
        format: "int64",
    },
    rumBrowserAndMobileSessionCount: {
        baseName: "rum_browser_and_mobile_session_count",
        type: "number",
        format: "int64",
    },
    rumSessionCountSum: {
        baseName: "rum_session_count_sum",
        type: "number",
        format: "int64",
    },
    rumTotalSessionCountSum: {
        baseName: "rum_total_session_count_sum",
        type: "number",
        format: "int64",
    },
    rumUnitsSum: {
        baseName: "rum_units_sum",
        type: "number",
        format: "int64",
    },
    sdsApmScannedBytesSum: {
        baseName: "sds_apm_scanned_bytes_sum",
        type: "number",
        format: "int64",
    },
    sdsEventsScannedBytesSum: {
        baseName: "sds_events_scanned_bytes_sum",
        type: "number",
        format: "int64",
    },
    sdsLogsScannedBytesSum: {
        baseName: "sds_logs_scanned_bytes_sum",
        type: "number",
        format: "int64",
    },
    sdsRumScannedBytesSum: {
        baseName: "sds_rum_scanned_bytes_sum",
        type: "number",
        format: "int64",
    },
    sdsTotalScannedBytesSum: {
        baseName: "sds_total_scanned_bytes_sum",
        type: "number",
        format: "int64",
    },
    serverlessAppsAzureCountAvg: {
        baseName: "serverless_apps_azure_count_avg",
        type: "number",
        format: "int64",
    },
    serverlessAppsGoogleCountAvg: {
        baseName: "serverless_apps_google_count_avg",
        type: "number",
        format: "int64",
    },
    serverlessAppsTotalCountAvg: {
        baseName: "serverless_apps_total_count_avg",
        type: "number",
        format: "int64",
    },
    syntheticsBrowserCheckCallsCountSum: {
        baseName: "synthetics_browser_check_calls_count_sum",
        type: "number",
        format: "int64",
    },
    syntheticsCheckCallsCountSum: {
        baseName: "synthetics_check_calls_count_sum",
        type: "number",
        format: "int64",
    },
    syntheticsMobileTestRunsSum: {
        baseName: "synthetics_mobile_test_runs_sum",
        type: "number",
        format: "int64",
    },
    syntheticsParallelTestingMaxSlotsHwm: {
        baseName: "synthetics_parallel_testing_max_slots_hwm",
        type: "number",
        format: "int64",
    },
    traceSearchIndexedEventsCountSum: {
        baseName: "trace_search_indexed_events_count_sum",
        type: "number",
        format: "int64",
    },
    twolIngestedEventsBytesSum: {
        baseName: "twol_ingested_events_bytes_sum",
        type: "number",
        format: "int64",
    },
    universalServiceMonitoringHostTop99p: {
        baseName: "universal_service_monitoring_host_top99p",
        type: "number",
        format: "int64",
    },
    vsphereHostTop99p: {
        baseName: "vsphere_host_top99p",
        type: "number",
        format: "int64",
    },
    vulnManagementHostCountTop99p: {
        baseName: "vuln_management_host_count_top99p",
        type: "number",
        format: "int64",
    },
    workflowExecutionsUsageSum: {
        baseName: "workflow_executions_usage_sum",
        type: "number",
        format: "int64",
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=UsageSummaryDate.js.map